import { delay } from '@/utils/utils.js';

window.onload = function () {
  const body = document.querySelector('body');
  body.addEventListener('click', (e) => {
    const sidebar = document.getElementById('sidebar');
    const mainContent = document.getElementById('main-content');
    if (e.target.id === 'sidebar-toggle') {
      console.log(sidebar.className);
      if (sidebar.className.indexOf('hide-left-bar') > -1 && mainContent.className.indexOf('merge-left') === -1) {
        mainContent.classList.toggle('merge-left');
      } else if (sidebar.className.indexOf('hide-left-bar') > -1 && mainContent.className.indexOf('merge-left') > -1) {
        sidebar.classList.toggle('hide-left-bar');
        mainContent.classList.toggle('merge-left');
      } else {
        sidebar.classList.toggle('hide-left-bar');
        mainContent.classList.toggle('merge-left');
      }
    }
  });
  // 滚动条在Y轴上的滚动距离
  function getScrollTop() {
    let scrollTop = 0;
    let bodyScrollTop = 0;
    let documentScrollTop = 0;
    if (document.body) {
      bodyScrollTop = document.body.scrollTop;
    }
    if (document.documentElement) {
      documentScrollTop = document.documentElement.scrollTop;
    }
    scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
    return scrollTop;
  }
  // 文档的总高度
  function getScrollHeight() {
    let scrollHeight = 0;
    let bodyScrollHeight = 0;
    let documentScrollHeight = 0;
    if (document.body) {
      bodyScrollHeight = document.body.scrollHeight;
    }
    if (document.documentElement) {
      documentScrollHeight = document.documentElement.scrollHeight;
    }
    scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ?
      bodyScrollHeight : documentScrollHeight;
    return scrollHeight;
  }
  // 浏览器视口的高度
  function getWindowHeight() {
    let windowHeight = 0;
    if (document.compatMode === 'CSS1Compat') {
      windowHeight = document.documentElement.clientHeight;
    } else {
      windowHeight = document.body.clientHeight;
    }
    return windowHeight;
  }
  const returnTop = document.getElementById('returnTop'); // 返回顶部按钮
  const returnDown = document.getElementById('returnDown'); // 返回底部按钮

  function reCalScroll() {
    if (returnTop && (getWindowHeight() === getScrollHeight())) {
      returnTop.classList.add('fadeComponentUp');
      returnDown.classList.add('fadeComponentDown');
    }
    delay(0.5).then(reCalScroll);
  }
  reCalScroll();
  window.onscroll = function () { // 滚动条滚动事件 // 获取滚动条的滚动高度
    if (!returnTop) {
      return false;
    }
    setTimeout(() => {
      if (getWindowHeight() === getScrollHeight()) {
        returnTop.classList.add('fadeComponentUp');
        returnDown.classList.add('fadeComponentDown');
      }
    }, 50);
    if (getScrollHeight() > getWindowHeight()) {
      if (getScrollTop() + getWindowHeight() === getScrollHeight()) {
        returnTop.classList.remove('fadeComponentUp');
        returnDown.classList.add('fadeComponentDown');
      } else if (getWindowHeight() === getScrollHeight()) {
        returnTop.classList.add('fadeComponentUp');
        returnDown.classList.add('fadeComponentDown');
      } else if (getScrollTop() === 0) {
        returnTop.classList.add('fadeComponentUp');
        returnDown.classList.remove('fadeComponentDown');
      } else {
        returnTop.classList.remove('fadeComponentUp');
        returnDown.classList.remove('fadeComponentDown');
      }
    }
  };

  if (returnTop && returnDown) {
    returnTop.onclick = function () { // 回到顶部按钮点击事件
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    returnDown.onclick = function () { // 回到底部按钮事件
      document.documentElement.scrollTop = getScrollHeight();
      document.body.scrollTop = getScrollHeight();
    };
  }
};
